import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { unregister } from './registerServiceWorker';
import { AsyncStorage } from 'react-native-web';

ReactDOM.render(<App />, document.getElementById('root'));
serviceWorkerRegistration.unregister();